import React, { useState, useEffect, useMemo } from "react";
import { ArrowLeft, PlusCircle, Eye, Edit, Edit2, Trash2 } from "react-feather";
import { Link } from "react-router-dom";
import Table from "core/pagination/datatable";
import TableTop from "Components/UI/TableTop";
import { useTableSearch } from "core/Operations/useTableSearch";
import { useForm, FormProvider, useFormContext } from "react-hook-form";
import { format } from "date-fns";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import { all_routes } from "Router/all_routes";
import LoadingSpinner from "Components/UI/LoadingSpinner";
import Error404 from "MainPages/ErrorPages/error404";
import { vehicleAccidentValidationSchema } from "core/Operations/ValidationSchema/MasterValidationSchema";
import { yupResolver } from "@hookform/resolvers/yup";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Popconfirm, Switch } from "antd";
import {
  useVehicleAccidentCategoriesQuery,
  useDeleteVehicleAccidentMutation,
  useInsertVehicleAccidentMutation,
  useUpdateVehicleAccidentMutation,
} from "AppQuries/master/VehicleAccident/vehicleaccident";

import { toast } from "core/Operations/toast";
import { BackIcon } from "Components/UI/Icon/Icons";
import { numberToPointNumber } from "MainPages/Utils/decimal.utils";
import VehicleAccidentModal from "Components/Modal/master/VehicleAccidentModal";
import { formatDate } from "core/Operations/dateFormat";

const VehicleAccident = () => {
  const userData = useSelector(loggedInUser);
  const [showActiveOnly, setShowActiveOnly] = useState(true);
  const [isMount, setIsMount] = useState(false);
  const { watch, setValue } = useFormContext();
  // const {
  //   data,
  //   isLoading,
  //   isError,
  //   error,
  //   refetch: GetItems,
  // } = useVehicleAccidentCategoriesQuery(
  //   {
  //     companyCode: userData?.companyCode,
  //     isTrue: true,
  //   },
  //   {
  //     enabled: userData?.companyCode,
  //   }
  // );
  const methods = useForm({
    resolver: yupResolver(vehicleAccidentValidationSchema),
  });
  const [isFilterVisible, setIsFilterVisible] = useState(false);

  const { mutateAsync: insertVehicleAccident, isPending: isAdding } =
    useInsertVehicleAccidentMutation();
  const { mutateAsync: updateVehicleAccident, isPending: isUpdating } =
    useUpdateVehicleAccidentMutation();

  const { mutateAsync: deleteVehicleAccident, isPending: isDeleting } =
    useDeleteVehicleAccidentMutation();
  const [selectedItem, setSelectedItem] = useState(null);

  const [show, setShow] = useState(false);
  const handleClose = () => {
    methods.reset();
    setShow(false);
  };
  const handleShow = () => setShow(true);

  const handleAddClick = () => {
    setSelectedItem(null);
    methods.reset({
      companyCode: userData.companyCode,
      accidentID: 0,
      accidentDate: "",
      accidentLocation: "",
      driverName: "",
      driverContactNumber: "",
      refundFromInsuranceAmount: "",
      actualRepairingAmount: "",
      vehicleNumber: "",
      isActive: true,
      createUser: userData.userName,
      createDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
        new Date(),
        "HH:mm:ss.SSS"
      )}Z`,
      modifyUser: userData.userName,
      modifyDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
        new Date(),
        "HH:mm:ss.SSS"
      )}Z`,
    });
    setShow(true);
  };

  const handleEditClick = (item) => {
    setSelectedItem(item);
    console.log(formatDate(item.accidentDate, "yyyy-MM-dd"));
    console.log(format(new Date(item.accidentDate), "yyyy-MM-dd"));

    methods.reset({
      companyCode: userData?.companyCode,

      accidentID: item.accidentID,
      accidentDate: format(new Date(item.accidentDate), "yyyy-MM-dd"),
      accidentLocation: item.accidentLocation,
      driverName: item.driverName,
      driverContactNumber: item.driverContactNumber,
      refundFromInsuranceAmount: numberToPointNumber(
        item.refundFromInsuranceAmount
      ),
      actualRepairingAmount: numberToPointNumber(item.actualRepairingAmount),
      vehicleNumber: item.vehicleNumber,
      isActive: item.isActive,
      createUser: item.createUser,
      createDate: item.createDate,
      modifyUser: userData.userName,
      modifyDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
        new Date(),
        "HH:mm:ss.SSS"
      )}Z`,
    });
    setShow(true);
  };

  const deleteItemHandler = (id) => {
    const payload = {
      companyCode: userData?.companyCode,
      code: id,
    };
    deleteVehicleAccident(payload, {
      onSuccess: (data) => {
        if (data) {
          toast.success("Item Deleted Successfully.");

          setSelectedItem(null);
          setShow(false);
          // GetItems();
        } else {
          toast.warning(data?.[0]?.errorMessage || "Something went wrong.");
        }
      },
      onError: (error) => {
        toast.error(error.message || "Something went wrong.");
      },
    });
  };

  const onSubmit = async (payload) => {
    // if (selectedItem) {
    //   updateVehicleAccident(payload, {
    //     onSuccess: (data) => {
    //       if (data) {
    //         toast.success("Updated Successfully");
    //         setSelectedItem(null);
    //         setShow(false);
    //         GetItems();
    //       } else {
    //         toast.warning(data?.[0]?.errorMessage || "Something went wrong.");
    //       }
    //     },
    //     onError: (error) => {
    //       toast.error(error.message || "Something went wrong.");
    //     },
    //   });
    // } else {
    //   insertVehicleAccident(payload, {
    //     onSuccess: (data) => {
    //       if (data) {
    //         toast.success("Created Successfully.");
    //         setShow(false);
    //         GetItems();
    //       } else {
    //         toast.warning(data?.[0]?.errorMessage || "Something went wrong.");
    //       }
    //     },
    //     onError: (error) => {
    //       toast.error(error.message || "Something went wrong.");
    //     },
    //   });
    // }
    if (selectedItem) {
      console.log(payload);
      const existingDataIndex = watch("vehicleAccidentList")?.findIndex(
        (item) => item.accidentID === selectedItem.accidentID
      );
      const existingData = watch("vehicleAccidentList");

      existingData[existingDataIndex] = payload;

      setValue("vehicleAccidentList", [...existingData]);
    } else {
      const existingData = watch("vehicleAccidentList") || [];

      const newList =
        existingData.length > 0 ? [...existingData, payload] : [payload];

      setValue("vehicleAccidentList", newList);
    }
    setShow(false);
  };

  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };

  const columns = useMemo(() => [
    {
      title: "Accident Date",
      dataIndex: "accidentDate",
      key: "accidentDate",
      render: (text) => <div>{format(new Date(text), "dd-MM-yyyy")}</div>,
    },
    {
      title: "Accident Location",
      dataIndex: "accidentLocation",
      key: "accidentLocation",
    },
    { title: "Driver Name", dataIndex: "driverName", key: "driverName" },
    {
      title: "Driver Contact Number",
      dataIndex: "driverContactNumber",
      key: "driverContactNumber",
    },
    {
      title: "Refund Amount",
      dataIndex: "refundFromInsuranceAmount",
      key: "refundFromInsuranceAmount",
    },
    {
      title: "Repairing Amount",
      dataIndex: "actualRepairingAmount",
      key: "actualRepairingAmount",
    },
    {
      title: "Vehicle Number",
      dataIndex: "vehicleNumber",
      key: "vehicleNumber",
    },
    {
      title: "Status",
      dataIndex: "isActive",
      render: (text, record) => (
        <>
          {text === true && (
            <div className="badges badge-linesuccess">Active</div>
          )}
          {text === false && (
            <div className="badges badge-linedanger">In Active</div>
          )}
        </>
      ),
    },
    {
      title: "Action",
      dataIndex: "action",
      className: "action-table-data",
      render: (text, record) => (
        <div className="edit-delete-action">
          <div className="input-block add-lists"></div>

          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id="add-new-tooltip">Edit</Tooltip>}
          >
            <Link className="me-2 p-2" onClick={() => handleEditClick(record)}>
              <Edit className="feather-edit" />
            </Link>
          </OverlayTrigger>

          {/* <OverlayTrigger
            placement="top"
            overlay={<Tooltip id="add-new-tooltip">Delete</Tooltip>}
          >
            <Link className="me-2 p-2" to="#">
              <Popconfirm
                title="Are you sure to Delete?"
                onConfirm={() => deleteItemHandler(record.code)}
              >
                <Trash2 className="feather-delete" />
              </Popconfirm>
            </Link>
          </OverlayTrigger> */}
        </div>
      ),
    },
  ]);

  const searchColumns = columns.map((column) => column.dataIndex);
  const { setSearchValue, filteredData } = useTableSearch(
    watch("vehicleAccidentList"),
    searchColumns
  );

  // useEffect(() => {
  //   if (isMount) GetItems();

  //   setIsMount(true);
  // }, [showActiveOnly]);

  // if (isLoading || isAdding || isUpdating) {
  //   return <LoadingSpinner />;
  // }

  // if (isError) {
  //   return <Error404 error={error} />;
  // }

  return (
    <>
      <h4 className="header-title">Accident</h4>

      <div className="card table-list-card border-0">
        <div className="card-body">
          <div className="d-flex justify-content-between align-items-center">
            <TableTop
              onSearch={setSearchValue}
              toggleFilterVisibility={toggleFilterVisibility}
              isFilterVisible={isFilterVisible}
            />
            <button
              className="btn btn-primary"
              onClick={handleAddClick}
              type="button"
            >
              Add New
            </button>
          </div>
          <div className="table-responsive">
            <Table
              className="table  datanew"
              columns={columns}
              dataSource={filteredData}
            />
          </div>
        </div>
      </div>

      <FormProvider {...methods}>
        <VehicleAccidentModal
          mode={selectedItem ? "E" : "I"}
          onSubmit={onSubmit}
          show={show}
          handleClose={handleClose}
        />
      </FormProvider>
    </>
  );
};

export default VehicleAccident;
